import { TellescopeModelFromName } from "../../mappings";

const DEFAULT_INBOX_STATUS = "New";

export const EXCLUDED_INBOX_THREAD_KEYS_FROM_TICKET_THREAD = [
  "id",
  "createdAt",
  "updatedAt",
  "businessId",
  "creator",
  "organizationIds",
  "sharedWithOrganizations",
] as const satisfies (keyof TellescopeModelFromName<"inbox_threads">)[];

type ExcludedInboxThreadKeys = (typeof EXCLUDED_INBOX_THREAD_KEYS_FROM_TICKET_THREAD)[number];
type PartialInboxThread = Omit<TellescopeModelFromName<"inbox_threads">, ExcludedInboxThreadKeys>;

export const removeTicketThreadExcludedInboxThreadFields = <
  T extends Partial<TellescopeModelFromName<"inbox_threads">>,
>(
  inboxThread: T
): PartialInboxThread => {
  const entries = Object.entries(inboxThread);
  return Object.fromEntries(
    entries.filter(([key]) => !EXCLUDED_INBOX_THREAD_KEYS_FROM_TICKET_THREAD.includes(key as ExcludedInboxThreadKeys))
  ) as PartialInboxThread;
};

/**
 * Converts a TicketThread to an InboxThread representation.
 *
 * Purpose: Used to determine if a new or updated ticket thread matches cached
 * inbox_threads load_threads filters to decide if the cache should be updated/invalidated.
 *
 * Note: Ticket threads map to the "Zendesk" inbox thread type.
 *
 * @param thread - The ticket thread to convert
 * @returns An InboxThread representation of the ticket thread
 */
export const convertTicketThreadToInboxThread = (
  thread: TellescopeModelFromName<"ticket_threads">
): PartialInboxThread => {
  return {
    type: "Zendesk",
    threadId: thread.id,
    title: thread.subject || "",
    preview: "",
    timestamp: new Date(thread.timestamp || thread.createdAt || new Date()),
    assignedTo: [],
    userIds: [],
    enduserIds: thread.enduserId ? [thread.enduserId] : [],
    inboxStatus: DEFAULT_INBOX_STATUS,
    tags: [],
    readBy: {},
    archivedAt: "",
    trashedAt: "",
  };
};
